const prefix = '@ISIMCodeValidator/';

export default {
  VALIDATE_CODE: `${prefix}VALIDATE_CODE`,
  VALIDATE_CODE_REQUEST: `${prefix}VALIDATE_CODE_REQUEST`,
  VALIDATE_CODE_REQUEST_SUCCESS: `${prefix}VALIDATE_CODE_REQUEST_SUCCESS`,
  VALIDATE_CODE_REQUEST_ERROR: `${prefix}VALIDATE_CODE_REQUEST_ERROR`,
};
